import $ from 'jquery'

const delimiter = '_'
const hideClass = 'd-none'
const activeSelector = 'div[data-active="true"]'

const hashStack = []

const navigateToSection = function (e) {
  const el = $(this)
  const sectionId = [el.parent().attr('id'), el.data('sec')].join(delimiter)
  updateHash(sectionId)
}

function updateHash (hash) {
  window.location.hash = hash
}

const activateSection = function (sectionId) {
  if (hashStack[hashStack.length - 1] === sectionId) return

  const el = $('#' + sectionId)

  hashStack.push(sectionId)

  $(activeSelector)
    .attr('data-active', 'false')
    .addClass(hideClass)

  el.attr('data-active', 'true')
    .removeClass(hideClass)

  if (hasParent(el.attr('id'))) {
    $('#back-btn').removeClass(hideClass)
    $('#faq-title').addClass(hideClass)
  } else {
    $('#back-btn').addClass(hideClass)
    $('#faq-title').removeClass(hideClass)
  }
}

const backHandler = function (e) {
  hashStack.pop() // remove current active section from stack
  updateHash(hashStack.pop())
}

const hasParent = function (id) {
  return id.split(delimiter).length > 1
}

const initHashStack = function (sectionId) {
  for (let i = 0; i < sectionId.length; i++) {
    if (sectionId[i] === delimiter) hashStack.push(sectionId.substr(0, i))
  }
}

const hashChageHandler = function (init) {
  const sectionId = ($(window.location.hash).length ? $(window.location.hash) : $(activeSelector)).attr('id')
  init === true && initHashStack(sectionId)
  activateSection(sectionId)
}

export const registerHandlers = function () {
  $('.faq').on('click', 'div', navigateToSection)
  $('#back-btn').on('click', backHandler)
  $(window).on('hashchange', hashChageHandler)

  hashChageHandler(true)
}
